import { render, staticRenderFns } from "./PaymentsComponent.vue?vue&type=template&id=a5e1ca32&scoped=true&lang=html&"
import script from "./PaymentsComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsComponent.vue?vue&type=style&index=0&id=a5e1ca32&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e1ca32",
  null
  
)

export default component.exports